import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestRoutes } from '../_config/rest-routes.config';
import { StateMaster } from '../_models/state-master.model';
import { environment } from 'src/environments/environment';
import { DashBoardResponse } from '../_models/dashboard-response.model';


@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  httpOptions = {
    headers: new HttpHeaders(
      {
        'Content-type': 'application/json'
      }
    )
  };

  constructor(private http: HttpClient) { }

  Get(MetricId: string, filters: any): Observable<DashBoardResponse> {
    let urlCommerces: string = `${environment.urlWS}${RestRoutes.DASHBOARD.replace('{METRICID}', MetricId)}`;
    return this.http.post<DashBoardResponse>(urlCommerces, filters, this.httpOptions);
  }



}
